import { UseToastIntercept } from '@app:store';
import { ProductionLine } from '@app:types';
import { StoreState } from 'store/store';
import { ServerResponses, WebsocketAction } from '../../providers/websocket/types';
import { ActionContext } from '../types';
import { LocationMutations } from './locations.reducer';

const actions: ActionContext<StoreState, LocationMutations> = {
  async set({ mutate }, payload: { id: string; name?: string }) {
    mutate(LocationMutations.SET_LOCATION, payload);
  },

  async processMessage(injectee, action: WebsocketAction<ServerResponses>) {
    switch (action.type) {
      case 'location.update':
        await this.updateState(injectee, action.payload.productionLines);
        break;
      case 'location.notify':
        throw new UseToastIntercept({
          duration: 3000,
          isClosable: true,
          title: action.payload.action,
          description: action.payload.description,
          status: action.payload.type || 'info',
        });
      default:
        throw new Error('Message type not implemented.');
    }
  },

  async updateState({ mutate }, payload: ProductionLine[]) {
    payload.forEach((line) => mutate(LocationMutations.SET_PRODUCTION_LINE, line));
  },
};

export default actions;
